import React from "react";

export default function UserCard({ user_id }) {
	return (
		<div className="rounded border border-gray-200 bg-white p-4">
			<div className="text-sm text-gray-500">User</div>
			<div className="text-lg font-semibold">#{user_id}</div>
		</div>
	);
}
